import { gridClasses, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import { DateTime } from "luxon";
import React from "react";
import { padTime } from "../util/dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../util/timeZoneService";

export default function AdminTradeFormToolbar(props) {
  const date = DateTime.now().setZone(getTimeZoneFromSwaStation(props.station));
  const fileName = `STARS_Trades_${padTime(date.month)}-${padTime(date.day)}-${date.year}_${padTime(
    date.hour
  )}${padTime(date.minute)}`;
  const columns = [
    "station",
    "referenceNumber",
    "tradeFormType",
    "shiftWorkgroup",
    "visibleTradeStatusAdminCSV",
    "createdAt",
    "employee1Name",
    "employee1Id",
    "employee1Workgroup",
    "employee1AcquiredShift",
    "employee1ReliefShift",
    "employee2Name",
    "employee2Id",
    "employee2Workgroup",
    "employee2AcquiredShift",
    "employee2ReliefShift",
    "supervisorInvolved",
  ];
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport csvOptions={{ fileName: fileName, fields: columns }} printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}
